import { Section } from 'components'
import { UtilitiesAndAmenities } from 'containers'
import { useSelector } from 'store'
import { selectPublicListingUtilitiesAndAmenities } from 'store/public-listing'

export const ListingUtilitiesAmenitiesSection = () => {
  const utilitiesAndAmenities = useSelector(selectPublicListingUtilitiesAndAmenities)
  return (
    <Section title="Utilities & Amenities">
      <UtilitiesAndAmenities utilitiesAndAmenities={utilitiesAndAmenities} />
    </Section>
  )
}
